import type { Address } from '@/types/nest/customer'
import { computed, ref, type Ref } from 'vue'

export function useAddressValidation(address: Ref<Address>) {
  const submitted = ref(false)

  const errors = computed(() => {
    const data = address.value
    const result: Partial<Record<keyof Address, string>> = {}

    if (data.street?.trim().length === 0) {
      result.street = 'Street cannot be empty'
    }

    if (data.country?.trim().length === 0) {
      result.country = 'Country cannot be empty'
    }

    if (data.postalCode?.trim().length === 0) {
      result.postalCode = 'Postal code cannot be empty'
    }

    if (data.city?.trim().length === 0) {
      result.city = 'Street cannot be empty'
    }

    if (data.houseNumber?.trim().length === 0) {
      result.houseNumber = 'Street cannot be empty'
    }

    return result
  })

  const visibleErrors = computed<Partial<Record<keyof Address, string>>>(() => {
    if (!submitted.value) return {}
    return errors.value
  })

  const isValid = computed(() => Object.keys(errors.value).length === 0)
  const isSubmittedAndInvalid = computed(() => submitted.value && !isValid.value)

  function validate(): boolean {
    submitted.value = true
    return isValid.value
  }

  return { errors, visibleErrors, isValid, submitted, isSubmittedAndInvalid, validate }
}
